
export default function FooterText() {

    return (
        <div className="footerText center">
            Copyright © All rights reserved.
        </div>
    );
}